import React, { useState } from "react";
import axios from "../api/baseurl";
import { useNavigate, Link } from "react-router-dom";
import AdminDashboard from "./admindashboard";
import "./hm-theme.css";

function Security() {
  const token = JSON.parse(localStorage.getItem("data"))?.token;

  const [pass, setpass] = useState({
    password: "",
    passwordConfirm: "",
  });
  const navigate = useNavigate();

  const handleChange = (event, field) => {
    let actualValue = event.target.value;
    setpass({ ...pass, [field]: actualValue });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    axios
      .post("/api/changePassword", pass, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => response.data)
      .then(
        (result) => {
          alert("Password Changed Successfully");
          navigate("/Signin");
        },
        (error) => {
          alert(error.response?.data?.message || "Failed to change password");
        }
      );
  };

  return (
    <div>
      <AdminDashboard />
      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">
          {/* Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">security</i>
                Account Settings - Security
              </h2>
              <p className="hm-page-subtitle">
                Manage your account security, password, and privacy preferences.
              </p>
            </div>
          </div>

          {/* Navigation Tabs */}
          <div className="d-flex align-items-center gap-3 border-bottom mb-4 pb-2">
            <Link
              to="/users/notification"
              className="text-decoration-none px-3 py-2 rounded-pill small fw-semibold text-secondary"
            >
              <i className="material-icons align-middle me-1" style={{ fontSize: "1.1rem" }}>notifications</i>
              Notifications
            </Link>
            <Link
              to="/users/security"
              className="text-decoration-none px-3 py-2 rounded-pill small fw-semibold text-primary bg-primary bg-opacity-10"
            >
              <i className="material-icons align-middle me-1" style={{ fontSize: "1.1rem" }}>shield</i>
              Security
            </Link>
          </div>

          {/* Change Password Card */}
          <div className="hm-card mb-4">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">lock</i>
                Change Password
              </h3>
            </div>
            <div className="hm-card-body p-4">
              <p className="text-muted small mb-4">
                New passwords must contain at least 8 characters.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label htmlFor="password" className="form-label small fw-semibold">New Password</label>
                    <input
                      className="form-control"
                      placeholder="Enter new password"
                      type="password"
                      id="password"
                      value={pass.password}
                      onChange={(e) => handleChange(e, "password")}
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="passwordConfirm" className="form-label small fw-semibold">Confirm Password</label>
                    <input
                      className="form-control"
                      placeholder="Confirm password"
                      type="password"
                      id="passwordConfirm"
                      value={pass.passwordConfirm}
                      onChange={(e) => handleChange(e, "passwordConfirm")}
                    />
                  </div>
                </div>

                <div className="mt-4 text-end">
                  <button className="btn-hm-primary px-4" type="submit">
                    <i className="material-icons me-1" style={{ fontSize: "1rem" }}>key</i>
                    Reset Password
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* Security Preferences Card */}
          <div className="hm-card mb-4">
            <div className="hm-card-header">
              <h3 className="hm-card-title">
                <i className="material-icons">admin_panel_settings</i>
                Security Preferences
              </h3>
            </div>
            <div className="hm-card-body p-4">
              <div className="mb-4">
                <h6 className="fw-bold mb-1" style={{ color: "#1e293b" }}>Account Privacy</h6>
                <p className="small text-muted mb-3">
                  By setting your account to private, your profile information and posts will not be visible to users outside of your user groups.
                </p>
                <div className="form-check mb-2">
                  <input className="form-check-input" type="radio" name="securityPreference" id="privacyPublic" defaultChecked />
                  <label className="form-check-label small" htmlFor="privacyPublic">
                    Public (posts are available to all users)
                  </label>
                </div>
                <div className="form-check mb-2">
                  <input className="form-check-input" type="radio" name="securityPreference" id="privacyPrivate" />
                  <label className="form-check-label small" htmlFor="privacyPrivate">
                    Private (posts are available to only users in your groups)
                  </label>
                </div>
              </div>

              <hr className="my-4" />

              <div>
                <h6 className="fw-bold mb-1" style={{ color: "#1e293b" }}>Data Sharing</h6>
                <p className="small text-muted mb-3">
                  Sharing usage data can help us to improve our products and better serve our users as they navigate through our application.
                </p>
                <div className="form-check mb-2">
                  <input className="form-check-input" type="radio" name="dataSharing" id="shareYes" defaultChecked />
                  <label className="form-check-label small" htmlFor="shareYes">
                    Yes, share data and crash reports with app developers
                  </label>
                </div>
                <div className="form-check mb-2">
                  <input className="form-check-input" type="radio" name="dataSharing" id="shareNo" />
                  <label className="form-check-label small" htmlFor="shareNo">
                    No, limit my data sharing with app developers
                  </label>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Security;

